
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/Day-And-Night-Diapers",
      function () {
        return require("private-next-pages/category/Day-And-Night-Diapers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/Day-And-Night-Diapers"])
      });
    }
  